export { stripFunnelPrefix } from '../../shared/funnelPath';

export function useFunnelPrefix(): string {
  const funnelId = useFunnelContext().value;

  return funnelId && funnelId !== 'baseline' ? `/${funnelId}` : '';
}
